import React from 'react';
import { Link } from 'react-router-dom';
import { FiZap, FiCheckCircle, FiClock, FiEye, FiFileText } from 'react-icons/fi';

const getPdlCollectionStatus = (pdl) => {
  switch (pdl.collection_status) {
    case 'completed': 
      return { text: 'Complet', color: 'green', icon: FiCheckCircle };
    case 'submitted': 
      return { text: 'Soumis', color: 'blue', icon: FiClock };
    default: 
      return { text: 'En cours', color: 'yellow', icon: FiClock };
  }
};

const PDLDocumentsTable = ({ pdls }) => {
  const colorClasses = {
    green: 'bg-green-100 text-green-800',
    yellow: 'bg-yellow-100 text-yellow-800',
    blue: 'bg-blue-100 text-blue-800',
  };

  if (!pdls || pdls.length === 0) {
    return (
      <div className="bg-white rounded-xl shadow-lg p-12 text-center border border-gray-200">
        <FiFileText className="w-16 h-16 text-gray-300 mx-auto mb-4" />
        <p className="text-gray-500 text-lg">Aucun PDL à afficher</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Point de Livraison
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Statut Dossier
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Documents fournis
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {pdls.map(pdl => {
            const statusInfo = getPdlCollectionStatus(pdl);
            const totalFilesForPdl = (pdl.documents || []).length;

            return (
              <tr key={pdl.id} className="hover:bg-gray-50 transition-colors">
                <td className="px-6 py-4">
                  <div className="flex items-center">
                    <div className="p-2 bg-blue-100 rounded-full mr-3">
                      <FiZap className="w-5 h-5 text-blue-600" />
                    </div>
                    <div>
                      <div className="text-sm font-medium text-gray-900">{pdl.site_name}</div>
                      <div className="text-sm text-gray-500 font-mono">{pdl.pdl_number}</div>
                    </div>
                  </div>
                </td>
                
                <td className="px-6 py-4">
                  <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold ${colorClasses[statusInfo.color]}`}>
                    <statusInfo.icon size={14} />
                    {statusInfo.text}
                  </span>
                </td>
                
                <td className="px-6 py-4">
                  <div className="flex items-center">
                    <FiFileText className="w-4 h-4 text-gray-400 mr-2" />
                    <span className="text-sm text-gray-700 font-medium">{totalFilesForPdl}</span>
                    <span className="text-sm text-gray-500 ml-1">fichier{totalFilesForPdl !== 1 ? 's' : ''}</span>
                  </div>
                </td>
                
                <td className="px-6 py-4 text-right">
                  <Link
                    to={`/dashboard/documents/${pdl.id}`}
                    className="inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-semibold rounded-lg hover:bg-blue-700 transition-colors"
                  >
                    <FiEye size={16} className="mr-2" />
                    Consulter
                  </Link>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default PDLDocumentsTable;
